import { tchDepartmentOptions } from "../helpers/GlobalOptions";

export const assignSupplierName = (supplier_name = "") => {
  if (typeof supplier_name == "string" && supplier_name.includes("tch_")) {
    const currentTch = tchDepartmentOptions.find(
      (option) => option.value == supplier_name
    );
    if (currentTch?.label) {
      supplier_name = `[TCH pickup] ${currentTch.label}`;
    }
  }

  if (typeof supplier_name == "string" && supplier_name.includes("vv_")) {
    const currentTch = [
      ...tchDepartmentOptions,

      {
        label: "Paryžiaus sandelis",
        value: "",
        rivile_codes: ["U080"],
      },
      {
        label: "Adremas lezas",
        value: "",
        rivile_codes: ["U0809"],
      },
      {
        label: "BB Paryžiaus sandelis",
        value: "",
        rivile_codes: ["U0711"],
      },
      {
        label: "Didmena Kauno sandėlis",
        value: "",
        rivile_codes: ["U072"],
      },
      {
        label: "VV Vlantana (U081)",
        value: "",
        rivile_codes: ["U081"],
      },
      {
        label: "BB Vlantana (U082)",
        value: "",
        rivile_codes: ["U082"],
      },
      {
        label: "VV + BB Vlantana (U083)",
        value: "",
        rivile_codes: ["U083"],
      },
    ].find(
      (option) =>
        Array.isArray(option.rivile_codes) &&
        option.rivile_codes.includes(
          supplier_name.replace("vv_", "").toUpperCase()
        )
    );
    if (currentTch?.label) {
      supplier_name = `[VV] ${currentTch.label}`;
    }
  }

  return supplier_name;
};
